import React from 'react';
import { Intl } from '@erecruit/core';
import { Button, H1, Modal, ModalProps } from '@erecruit/ui-kit';
import { Resources } from '@erecruit/types';
import { ButtonContainer } from '@erecruit/modules';

const { FormattedMessage } = Intl;

const MakeOfferModalTitle = (
  <H1>
    <FormattedMessage
      id={messageIds.vms.matchRecord.offerInterviewModal.makeOfferConfirm}
    />
  </H1>
);

const MakeOfferPageTitle = (
  <H1 color="headerTertiary">
    <FormattedMessage
      id={messageIds.vms.matchRecord.offerInterviewModal.makeOffer}
    />
  </H1>
);

const InviteForInterviewModalTitle = (
  <H1>
    <FormattedMessage
      id={
        messageIds.vms.matchRecord.offerInterviewModal.inviteForInterviewConfirm
      }
    />
  </H1>
);

const InviteForInterviewPageTitle = (
  <H1 color="headerTertiary">
    <FormattedMessage
      id={messageIds.vms.matchRecord.offerInterviewModal.inviteForInterview}
    />
  </H1>
);

export interface OfferInterviewModalProps extends ModalProps {
  onConfirm(): void;
  type:
    | Resources.MatchActionType.MakeOffer
    | Resources.MatchActionType.InviteForInterview;
}

const OfferInterviewModal = ({
  onConfirm,
  type,
  ...modalProps
}: OfferInterviewModalProps) => {
  return (
    <Modal
      {...modalProps}
      footer={false}
      width="642px"
      destroyOnClose
      pageTitle={
        type === Resources.MatchActionType.MakeOffer
          ? MakeOfferPageTitle
          : InviteForInterviewPageTitle
      }
    >
      {type === Resources.MatchActionType.MakeOffer
        ? MakeOfferModalTitle
        : InviteForInterviewModalTitle}
      <ButtonContainer>
        <Button size="large" onClick={modalProps.onCancel}>
          <FormattedMessage
            id={messageIds.vms.matchRecord.offerInterviewModal.cancel}
          />
        </Button>
        <Button size="large" key="confirm" type="primary" onClick={onConfirm}>
          <FormattedMessage
            id={messageIds.vms.matchRecord.offerInterviewModal.yes}
          />
        </Button>
      </ButtonContainer>
    </Modal>
  );
};

export default OfferInterviewModal;
